import endpoints from '../endpoints/me';

function fetchNetworkToken(networkId) {
  return endpoints.fetchNetworkToken.execute(null, { networkId });
}

function fetchTokenByTicket(ticket) {
  return endpoints.fetchTokenByTicket.execute(null, { ticket });
}

function getRoles() {
  return endpoints.getRoles.execute();
}

function login(spotId = undefined) {
  var payload = {};
  if (spotId) {
    payload.spot_id = spotId;
  }
  return endpoints.login.execute(payload);
}

function loginRegistered() {
  return endpoints.loginRegistered.execute();
}

function getNetworkIdByName(networkName) {
  return endpoints.getNetworkIdByName.execute(null, { networkName });
}

function getNetworkIdBySpotId(spotId) {
  return endpoints.getNetworkIdBySpotId.execute(null, { spotId });
}

function logout({ spotId, networkId }) {
  var payload = {};

  if (spotId || networkId) {
    if (spotId) {
      payload.spot_id = spotId;
    }

    if (networkId) {
      payload.network_id = networkId;
    }
  }
  let res = endpoints.logout.execute(payload);

  return res;
}

function getMyMultiSpots() {
  return endpoints.getMyMultiSpots.execute();
}

export default {
  fetchNetworkToken,
  fetchTokenByTicket,
  login,
  loginRegistered,
  logout,
  getNetworkIdByName,
  getNetworkIdBySpotId,
  getRoles,
  getMyMultiSpots
};
